module.exports = __webpack_public_path__ + "static/media/shield-frame.e0300008.svg";